import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";

export default function Partners() {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    axios
      .post(`${API_BASE_URL}/api/ourPartners/getAllourPartners`)
      .then((response) => {
        if (response?.data?.error === false) {
          const data = response.data.data?.our_partners?.our_partners_data || [];
          setLogos(data);
        }
      })
      .catch(() => {
        setLogos([]);
      });
  }, []);

  if (logos.length === 0) {
    return null;
  }

  // Render every partner managed from the admin panel. Adding a partner there
  // makes it appear here automatically — no hardcoded list to maintain.
  return (
    <div className="home-partners section-space">
      <div className="container">
        <h2 className="home-partners__heading">Our Partners</h2>
        <p className="home-partners__subtitle">
          We collaborate with the world&rsquo;s leading technology brands to deliver best-in-class solutions.
        </p>

        <div className="home-partners__grid">
          {logos.map((logo, index) => (
            <div className="partner-card" key={logo.id || index}>
              <img
                className="partner-card__logo"
                src={logo.image}
                alt={logo.altText || "Partner"}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
